import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/articles';
import { stats } from '@/mocks/categories';

export default function HomeHero() {
  return (
    <section className="relative pt-24 pb-16 md:pt-32 md:pb-24">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          <div className="lg:w-[35%] flex flex-col justify-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight tracking-tight">
              每日吃瓜
              <br />
              不迷路
            </h1>
            <p className="mt-4 md:mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-md">
              汇集全网最新网红爆料、明星黑料与热门追踪资讯。做最懂你的娱乐吃瓜平台，每日更新，精彩不断。
            </p>
            <div className="mt-6 md:mt-8 flex flex-wrap gap-3">
              <Link
                to="/category/remen-zhuizong"
                className="whitespace-nowrap px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors duration-200 cursor-pointer inline-flex items-center gap-2"
              >
                立即吃瓜
                <i className="ri-arrow-right-up-line"></i>
              </Link>
              <Link
                to="/category/chigua-shipin"
                className="whitespace-nowrap px-6 py-3 rounded-full border border-foreground-300 text-foreground-700 text-sm font-medium hover:border-primary-500 hover:text-primary-600 transition-colors duration-200 cursor-pointer"
              >
                看视频
              </Link>
            </div>

            <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4">
              {stats.map((stat) => (
                <div key={stat.label}>
                  <p className="text-xl md:text-2xl font-heading font-bold text-primary-600">
                    {stat.value}
                    <span className="text-sm font-normal text-foreground-500 ml-0.5">{stat.suffix}</span>
                  </p>
                  <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:w-[35%]">
            <div className="relative rounded-2xl overflow-hidden h-[350px] md:h-[450px] lg:h-[520px]">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20breaking%20news%20collage%20with%20warm%20crimson%20and%20amber%20abstract%20background%2C%20silhouettes%20of%20people%20reading%20news%20on%20phones%2C%20modern%20digital%20media%20concept%2C%20editorial%20style%20with%20bold%20contrast%2C%20warm%20lighting%2C%20sophisticated%20composition%2C%20no%20text%2C%20clean%20artistic%20aesthetic&width=800&height=1200&seq=hero-main-91-01&orientation=portrait"
                alt="91在线吃瓜 - 每日网红黑料吃瓜视频"
                title="91在线吃瓜网 网红爆料 吃瓜视频"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
            </div>
          </div>

          <div className="lg:w-[30%]">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-lg font-heading font-bold text-foreground-900">
                今日必看
              </h2>
              <i className="ri-arrow-right-up-line text-primary-500"></i>
            </div>
            <div className="grid grid-cols-1 gap-3">
              <Link
                to="/article/douyin-wanghong-baoliao-20260701"
                className="block rounded-xl overflow-hidden relative h-[220px] group cursor-pointer"
              >
                <img
                  src="https://readdy.ai/api/search-image?query=Dramatic%20breaking%20news%20illustration%20with%20a%20silhouetted%20figure%20against%20a%20warm%20red%20gradient%20background%2C%20abstract%20social%20media%20icons%20floating%2C%20editorial%20journalism%20style%20with%20striking%20contrast%2C%20warm%20amber%20and%20crimson%20tones%2C%20clean%20composition&width=600&height=450&seq=hero-top-card&orientation=landscape"
                  alt="某千万粉丝抖音网红被前助理爆出私生活混乱"
                  title="抖音网红 私生活爆料 聊天记录曝光"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium mb-2">
                    网红爆料
                  </span>
                  <h3 className="text-sm font-semibold text-white line-clamp-2 leading-snug">
                    某千万粉丝抖音网红被前助理爆出私生活混乱，聊天记录曝光引发全网热议
                  </h3>
                </div>
              </Link>
              <div className="grid grid-cols-2 gap-3">
                <Link
                  to="/article/zhiming-nvxing-heidong-20260703"
                  className="block rounded-xl overflow-hidden relative h-[140px] group cursor-pointer"
                >
                  <img
                    src="https://readdy.ai/api/search-image?query=Mysterious%20nighttime%20paparazzi%20style%20scene%20with%20warm%20city%20lights%20blurred%20in%20background%2C%20two%20silhouettes%20near%20a%20luxury%20hotel%20entrance%2C%20dramatic%20ambient%20lighting%2C%20cinematic%20mood&width=400&height=300&seq=hero-card-02&orientation=landscape"
                    alt="知名女星被拍到深夜密会神秘男子"
                    title="知名女星 恋情 酒店密会"
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-3">
                    <span className="inline-block px-2 py-0.5 rounded-full bg-accent-500/90 text-background-50 text-[10px] font-medium mb-1">
                      明星黑料
                    </span>
                    <h3 className="text-xs font-semibold text-white line-clamp-2 leading-snug">
                      知名女星被拍到深夜密会神秘男子，酒店同进同出引爆恋情猜测
                    </h3>
                  </div>
                </Link>
                <Link
                  to="/article/zhibo-quan-jingbao-20260704"
                  className="block rounded-xl overflow-hidden relative h-[140px] group cursor-pointer"
                >
                  <img
                    src="https://readdy.ai/api/search-image?query=Dramatic%20business%20investigation%20scene%20with%20abstract%20financial%20data%20visualization%20in%20dark%20red%20and%20amber%20tones%2C%20modern%20office%20setting%20with%20serious%20atmosphere%2C%20editorial%20style&width=400&height=300&seq=hero-card-03&orientation=landscape"
                    alt="直播圈大地震多位头部主播涉嫌偷税漏税"
                    title="直播圈 偷税漏税 头部主播"
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-3">
                    <span className="inline-block px-2 py-0.5 rounded-full bg-accent-500/90 text-background-50 text-[10px] font-medium mb-1">
                      热门追踪
                    </span>
                    <h3 className="text-xs font-semibold text-white line-clamp-2 leading-snug">
                      直播圈大地震！多位头部主播涉嫌偷税漏税被约谈
                    </h3>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}